//import messageStatusIcon from "../assets/icons/ascending Copy 80.svg";
//import generationTypeIcon from "../assets/icons/ascending Copy 78.svg";
//import routingTypeIcon from "../assets/icons/ascending Copy 76.svg";
//import gpiStatusIcon from "../assets/icons/ascending Copy 67.svg";
//import stateIcon from "../assets/icons/ascending Copy 72.svg";
//import chargesIcon from "../assets/icons/ascending Copy 71.svg";

export const getCountryIcon = async (country) => {
  if (country) {
    let key = country.toLowerCase();
    const icon = await import(`../assets/icons/country-flags/${key}.svg`);

    return icon.default;
  }
  return null;
};

export const getStateIcon = async (state) => {
  let icon;
  switch (state) {
    case "NONE":
      return null;
    case "NATIONAL":
      icon = await import("../assets/icons/NATIONAL-ICON.svg");
      break;
    case "INTERNATIONAL":
      icon = await import("../assets/icons/INTERNATIONAL-ICON.svg");
      break;
    default:
      return null;
  }

  return icon.default;
};

export const getGenerationTypeIcon = async (generationType) => {
  let icon;

  switch (generationType) {
    case "NONE":
      return null;
    case "RECEIVED":
      icon = await import("../assets/icons/SESTEM-RECIEVED.svg");
      break;
    case "MANUAL":
      icon = await import("../assets/icons/MANUAL-G.svg");
      break;
    case "AUTOMATIC":
      icon = await import("../assets/icons/AUTO-G.svg");
      break;
    default:
      return null;
  }
  return icon.default;
};

export const getRoutingTypeIcon = async (routingType) => {
  let icon;

  switch (routingType) {
    case "NONE":
      return null;
    case "SAA":
      icon = await import("../assets/icons/SSA-ICON.svg");
      break;
    case "AML_PASSED":
      icon = await import("../assets/icons/AML-PASSED-ICON.svg");
      break;
    case "AML_REJECTED":
      icon = await import("../assets/icons/AML-REJECTED-ICON.svg");
      break;
    case "AML_PENDING":
      icon = await import("../assets/icons/AML-PENDING-ICON.svg");
      break;
    default:
      return null;
  }
  return icon.default;
};

export const getGpiStatusIcon = async (gpiStatus) => {
  let icon;

  switch (gpiStatus) {
    case "NONE":
      return null;
    case "ACCC":
      icon = await import("../assets/icons/ACCC-ICON.svg");
      break;
    case "ACSP":
      icon = await import("../assets/icons/ACSP-ICON.svg");
      break;
    case "RJCT":
      icon = await import("../assets/icons/RJCT-ICON.svg");
      break;
    default:
      return null;
  }
  return icon.default;
};

export const getMessageStatusIcon = async (messageStatus) => {
  let icon;

  switch (messageStatus) {
    case "NONE":
      return null;
    case "ACK":
      icon = await import("../assets/icons/ACK-ICON.svg");
      break;
    case "NACK":
      icon = await import("../assets/icons/NACK-ICON.svg");
      break;
    default:
      return null;
  }
  return icon.default;
};

export const getChargeMessageIcon = async (chargeMessage) => {
  let icon;

  switch (chargeMessage) {
    case "NONE":
      return null;
    case "OUR":
      icon = await import("../assets/icons/OUR-ICON.svg");
      break;
    case "BEN":
      icon = await import("../assets/icons/BEN-ICON.svg");
      break;
    case "SHA":
      icon = await import("../assets/icons/SHA-ICON.svg");
      break;

    default:
      return null;
  }
  return icon.default;
};

export const getIcons = async (filters, country) => {
  const stateIcon = await getStateIcon(filters.state);
  const chargeMessageIcon = await getChargeMessageIcon(filters.chargeMessage);
  const messageStatusIcon = await getMessageStatusIcon(filters.messageStatus);
  const gpiStatusIcon = await getGpiStatusIcon(filters.gpiStatus);
  const routingTypeIcon = await getRoutingTypeIcon(filters.routingType);
  const countryIcon = await getCountryIcon(country);
  const generationTypeIcon = await getGenerationTypeIcon(
    filters.generationType
  );
  return {
    country: countryIcon,
    state: stateIcon,
    chargeMessage: chargeMessageIcon,
    messageStatus: messageStatusIcon,
    gpiStatus: gpiStatusIcon,
    routingType: routingTypeIcon,
    generationType: generationTypeIcon,
  };
};

export const getAllIcons = async () => {
  //message status
  const ACK = await getMessageStatusIcon("ACK");
  const NACK = await getMessageStatusIcon("NACK");

  //generation type
  const systemRecievedIcon = await getGenerationTypeIcon("RECEIVED");
  const autoGeneratedIcon = await getGenerationTypeIcon("AUTOMATIC");
  const manualGeneratedIcon = await getGenerationTypeIcon("MANUAL");

  //routing
  const SAA = await getRoutingTypeIcon("SAA");
  const AML_PASSED = await getRoutingTypeIcon("AML_PASSED");
  const AML_REJECTED = await getRoutingTypeIcon("AML_REJECTED");
  const AML_PENDING = await getRoutingTypeIcon("AML_PENDING");

  //gpi status
  const ACCC = await getGpiStatusIcon("ACCC");
  const ACSP = await getGpiStatusIcon("ACSP");
  const RJCT = await getGpiStatusIcon("RJCT");

  //charges
  const OUR = await getChargeMessageIcon("OUR");
  const BEN = await getChargeMessageIcon("BEN");
  const SHA = await getChargeMessageIcon("SHA");

  //NATIONAL/INTERNATIONAL
  const NATIONAL = await getStateIcon("NATIONAL");
  const INTERNATIONAL = await getStateIcon("INTERNATIONAL");

  return {
    ACK,
    NACK,
    systemRecievedIcon,
    autoGeneratedIcon,
    manualGeneratedIcon,
    SAA,
    AML_PASSED,
    AML_REJECTED,
    AML_PENDING,
    ACCC,
    ACSP,
    RJCT,
    OUR,
    BEN,
    SHA,
    NATIONAL,
    INTERNATIONAL,
  };
};

//export const getFilterIcon = (filter) => {
//  switch (filter) {
//    case "MESSAGE STATUS":
//      return messageStatusIcon;
//    case "GENERATION TYPE":
//      return generationTypeIcon;
//    case "ROUTING":
//      return routingTypeIcon;
//    case "GPI STATUS":
//      return gpiStatusIcon;
//    case "NATIONAL/INTERNATIONAL":
//      return stateIcon;
//    case "CHARGES":
//      return chargesIcon;
//    default:
//      return messageStatusIcon;
//  }
//};
